import { Application } from '@/types/application';
import { ComparerParam } from '@/types/comparer';
import { makeParam } from './comparerUtils';

export const compareMetadata = (appA: Application, appB: Application): ComparerParam[] => {
  const metadataKeys: (keyof Application)[] = ['applicationId', 'name', 'label', 'revision', 'generated', 'format'];

  return metadataKeys.map((key) => makeParam(key, appA[key], appB[key]));
};
